import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import inspirationAsset from "@/assets/home/inspiration-path.jpg.asset.json";
import { track } from "@/lib/track";
import { startMembershipJourney, MEMBERSHIP_JOURNEY_PATH } from "@/lib/funnel";


/**
 * Large full-width inspirational panel — a warm sunrise path illustration
 * with the Recovery Trauma™ reassurance message and a single gentle CTA.
 */
export function InspirationSection() {
  return (
    <section
      aria-labelledby="inspiration-heading"
      className="relative overflow-hidden rounded-[24px] border border-gold/30 shadow-[var(--shadow-gold)]"
    >
      <img
        src={inspirationAsset.url}
        alt="Illustration of a winding path through a wildflower meadow at sunrise, with trees, a stream and warm golden light."
        width={1920}
        height={912}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/75 to-background/20 dark:from-background/95 dark:via-background/80 dark:to-background/35"
      />

      <div className="relative mx-auto flex max-w-4xl flex-col items-start gap-4 px-5 py-10 sm:px-8 sm:py-14 lg:py-18">
        <h2
          id="inspiration-heading"
          className="max-w-2xl font-display text-xl leading-tight tracking-tight text-foreground sm:text-3xl lg:text-4xl"
        >
          Healing isn't about becoming someone new.{" "}
          <span className="italic text-[var(--gold-deep)]">
            It's about finding your way back to yourself.
          </span>
        </h2>
        <p className="max-w-xl text-sm leading-relaxed text-foreground/80 sm:text-base">
          Take your time. Rest when you need to. Celebrate every small step.
          Recovery Trauma™ is here whenever you're ready.
        </p>
        <Link
          to={MEMBERSHIP_JOURNEY_PATH}
          onClick={() => {
            track("cta_click", { cta: "start_recovery", flow: "membership_journey" }, { source: "home_inspiration" });
            startMembershipJourney("start_recovery", "home_inspiration");
          }}
          className="btn-gold btn-gold--compact-mobile group sm:text-base"
        >

          Start Your Recovery Today
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </section>
  );
}
